import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../app/rootReducer";
import {
  getProgramDurations,
  getInstitutionProgramDurations,
} from "../../slices/codeBookSlice";

export const useGetProgramDurations = () => {
  const programDurations = useSelector(
    (state: RootState) => state.codeBook.programDurations
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getProgramDurations());
  }, [dispatch]);

  return programDurations;
};

export const useGetInstitutionProgramDurations = (
  pedagogicalYearInstitutionId: number
) => {
  const filteredProgramDurations = useSelector(
    (state: RootState) => state.codeBook.filteredProgramDurations
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getInstitutionProgramDurations(pedagogicalYearInstitutionId));
  }, [pedagogicalYearInstitutionId, dispatch]);

  return filteredProgramDurations;
};
